import * as yup from "yup";
import { KarteContentMaxLength } from "../../../consts/KarteContentMaxLength";

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required("テンプレート名は必須です")
    .max(20, "テンプレート名は20文字以下で入力してください"),
  template: yup
    .string()
    .required("本文を入力してください")
    .max(
      KarteContentMaxLength,
      `本文は${KarteContentMaxLength}文字以下で入力してください`,
    ),
});
export default validationSchema;
